/** @format */

import template from './gb-edit-image-widget.html';
import './gb-edit-image-widget.scss';

export const GbEditImageWidgetComponent = {
    template,
    require: {
        gbEditTools: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbEditImageWidgetComponent {
        constructor() {
            'ngInject';

            this.excludeFields = ['color'];
        }
    },
};
